import React, { useEffect } from "react";
import "./previewform.css";
import Navbar from "../../helpers/Navbar";
import Stepper from "./Stepper";
import { useDispatch, useSelector } from "react-redux";
import { getMyEvents,clearError } from "../../../redux/reducers/eventSlice";
import {snackbarContext} from '../../helpers/Snakbar'
import {useNavigate} from 'react-router-dom'
import { clearUser, trackPreviewClick } from '../../../redux/reducers/authSlice';
import Loader from "../../helpers/Loader";
import { TabTitle } from "../../helpers/GeneralFunctions";
const PreviewForm = () => {
    TabTitle("Preview")
    const setStateSnackbarContext=React.useContext(snackbarContext)
   const {error:backendError,loading,guestLists}=useSelector((state)=>state.event)
     const {user,error:authError} = useSelector(state => state.auth);
       const now = new Date().getTime();
const expiryTime = new Date(user && user.demoExpiryTime).getTime();
const isDemoExpired = user && user.demoVersion && expiryTime && now > expiryTime;
    const dispatch=useDispatch()
    const navigate=useNavigate()

    const fetchEVents=()=>{
        dispatch(getMyEvents())
    }

      useEffect(()=>{
        if (backendError === "session expired" || backendError==="pls login to acess the resource") {
          setStateSnackbarContext(true, "session expired please login again", "error");
          dispatch(clearError());
          dispatch(clearUser())
          navigate("/login")
        } else if (backendError) {
          setStateSnackbarContext(true, backendError, "error");
          dispatch(clearError());
        }
      },[backendError])

   useEffect(()=>{
    fetchEVents()
  
    },[])

     if (authError === "session expired") {
            setStateSnackbarContext(true, "session expired please login again", "error");
            dispatch(clearError());
            dispatch(clearUser())
            navigate("/login")
          } else if (backendError) {
            setStateSnackbarContext(true, backendError, "error");
            dispatch(clearError());
          }

            if(loading){
    return <Loader/>
  }

  const handlePreview=()=>{
    if(user?.demoVersion && !user.dashboard?.previewViewed){
          dispatch(trackPreviewClick())
    }
   navigate(`/preview/${user && user.userCode}`)
  }

  if(isDemoExpired){
  navigate("/")
}

if(user && user.needsDate===true){
  navigate("/")
}

if(user && user.inviteTimeExpired){
 navigate("/")
}


  return (
    <>
      <Navbar />
      <Stepper step={3} demoVersion={user && user.demoVersion} />

      <div className="preview-page">

        <div className="preview-hero-card">

          <img
            src="/popper.png"
            alt="Invitation Ready"
            className="preview-hero-image"
          />

          <h2>Your Invitation is Ready</h2>

          <p>
           See how your invitation will look to your guests before you share it.
          </p>

          <button className="preview-main-btn" onClick={handlePreview}>
            👁 View Invitation
          </button>


           {guestLists && guestLists.length > 0 && (
  <>
    <div className="preview-divider"></div>

    <div className="guest-preview-section">

      <span className="guest-preview-heading">
        Guest Lists
      </span>

      {guestLists.map((guestList) => (
         
        <div
          className="guest-preview-row"
          key={guestList.code}
        >
          <span>{guestList.groupname}</span>

          <button   onClick={()=>navigate(`/preview/${user && user.userCode}?group=${guestList.code}`)}>
            Preview 
          </button>
        </div>
      ))}

    </div>
  </>
)} 

        </div>

      </div>

      <button className="preview-floating-btn"  onClick={()=>navigate("/share")}>
        Next: Share Your Invitation →
      </button>

    </>
  );
};

export default PreviewForm;